import React from 'react';

const UniversalReaderIntercom: React.FC<React.PropsWithChildren> = () => (
  <svg width="32" height="32" viewBox="0 0 24 24">
    <path d="M13 19.5C13 20.0523 12.5523 20.5 12 20.5C11.4477 20.5 11 20.0523 11 19.5C11 18.9477 11.4477 18.5 12 18.5C12.5523 18.5 13 18.9477 13 19.5Z" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 18V3C6 1.89543 6.89543 1 8 1H16L16.2041 1.01074C17.2128 1.113 18 1.96435 18 3V18V21C18 22.1046 17.1046 23 16 23H8C6.89543 23 6 22.1046 6 21V18ZM16 16H8V10.5H16V16ZM8 3H16V8.5H8V3ZM16 21H8V18H16V21Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 8C10.7574 8 9.75 6.99264 9.75 5.75C9.75 4.50736 10.7574 3.5 12 3.5C13.2426 3.5 14.25 4.50736 14.25 5.75C14.25 6.99264 13.2426 8 12 8ZM12 5C12.4142 5 12.75 5.33579 12.75 5.75C12.75 6.16421 12.4142 6.5 12 6.5C11.5858 6.5 11.25 6.16421 11.25 5.75C11.25 5.33579 11.5858 5 12 5Z"
    />
  </svg>
);

export default UniversalReaderIntercom;
